"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import '@membranehq/sdk';
import 'js-convert-case';
import { FieldDescription } from '../DataBuilder/FieldDescription.mjs';
import '../DataBuilderUI/FieldControlPanel/index.mjs';
import '../DataBuilderUI/ActionBar.mjs';
import { Cell } from '../DataBuilderUI/Cell.mjs';
import 'clsx';
import '../DataBuilderUI/styles.module.css.mjs';
import { Row } from '../DataBuilderUI/Row.mjs';
import { Title } from '../DataBuilderUI/Title.mjs';
import { simpleInputRecipe } from './recipe.mjs';

function SimpleInput({ label, value, description, onChange, className, rightSlot, ...props }) {
  const simpleInputClassNames = simpleInputRecipe({
    disabled: props.disabled
  });
  function handleChange(e) {
    onChange(e.target.value);
  }
  return /* @__PURE__ */ jsxs(Row, { className: simpleInputClassNames.row(), children: [
    label && /* @__PURE__ */ jsx(Cell, { type: "name", children: /* @__PURE__ */ jsx(Title, { rightSlot: /* @__PURE__ */ jsx(FieldDescription, { text: description }), children: /* @__PURE__ */ jsx("span", { className: simpleInputClassNames.title(), children: label }) }) }),
    /* @__PURE__ */ jsx(Cell, { className: simpleInputClassNames.cell(), span: "grow", children: /* @__PURE__ */ jsx(
      "input",
      {
        value: value ?? "",
        onChange: handleChange,
        disabled: props?.disabled,
        ...props,
        className: simpleInputClassNames.input({ className })
      }
    ) }),
    rightSlot && /* @__PURE__ */ jsx(Cell, { children: rightSlot })
  ] });
}

export { SimpleInput };
